import { interpolateNS } from '@core/utils';
import { defaultNS } from '@core/i18n/i18n';

export const commonNS = interpolateNS(defaultNS);
